{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Επιλογέας χρωμάτων",
  "twoDimensionalSlider": "Ρυθμιστικό 2D",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
